import { takeLatest, put, call } from 'redux-saga/effects';
import * as actions from './actions';
import * as types from './types';
import * as api from './api';

export function* fetch(action) {
  try {
    const resp = yield call(api.fetch);
    yield put(actions.fetchSucceeded(resp));
  }
  catch (err) {
    yield put(actions.fetchFailed());
  }
}

export function* watchCycles() {
  yield takeLatest(types.FETCH, fetch);
}
